/*
 * @Author: jiangxd
 * @Date: 2021-08-04 11:24:01
 * @LastEditTime: 2021-08-04 19:05:16
 * @LastEditors: jiangxd
 * @Description:
 * @FilePath: /rs_ips_maintence/src/services/empService/config.ts
 */
/**
 * Created by Qingger Corp.
 * User: jsspf
 * Date: 2017/11/21
 * Time: 12:32
 */

import merge from 'lodash/merge';
import isEmpty from 'lodash/isEmpty';
import type { BaseHttpRequestOption } from '@/util/type';
import { HttpMethod } from '@/util/type';

export namespace EmpResConfig {
  /**
   * 代理地址的路径
   * @type {string}
   */
  export const API_BASE_URL = '/emp';
  export const NEW_EMP_URL = '/new-emp';
  const API_BASE_URL_FOR_NODE = '/nips';

  export const EMP_PORTAL_LOGIN_URL = '/emp/auth/portal/oauth/login';
  export const NEW_EMP_PORTAL_LOGIN_URL = '/new-emp/auth/portal/oauth/login';

  export const EMP_PORTAL_AUTH_APIID = 'ADMINPORTAL';

  // 用户名密码方式登录
  export const EMP_PASSWORD_AUTH_APIID = 'USERPASSWORD';

  function resolveURLConfig(baseURL: string, tOut = 15000) {
    return function(path: string, method = HttpMethod.POST, name = '', options: ItemObject = {}, timeout: number = tOut): BaseHttpRequestOption {
      options.auth = options.auth !== false;

      options.authTokenKey = options.authTokenKey ? options.authTokenKey : null;

      let ret: BaseHttpRequestOption = {
        name,
        baseURL,
        path,
        method,
        timeout,
      };

      ret = merge({}, ret, options);
      if (!isEmpty(ret.name)) {
        ret.fromJson = true;
      }
      return ret;
    };
  }

  export const resolveEmpURLConfig = resolveURLConfig(API_BASE_URL);
  export const resolveNewEmpURLConfig = resolveURLConfig(NEW_EMP_URL);
  export const resolveIPSNodeURLConfig = resolveURLConfig(API_BASE_URL_FOR_NODE);

  /**
   * 接口资源定义
   * @type {{}}
   */
  export const APIResURLConfig = {
    /**
     * ADN3.获取集团信息
     * @see : https://wiki.qingger.cn/pages/viewpage.action?pageId=109674540
     */
    // GRT_GROUP_INFO: resolveIPSNodeURLConfig("/get/group/info", HttpMethod.POST, null, {
    //   auth: false,
    // }),
    GRT_GROUP_INFO: resolveIPSNodeURLConfig('/get/group/info', HttpMethod.POST, null, {
      auth: false,
    }),
    /**
     * 请求EmpService的Token
     * @apiDoc : http://git.project.qingger.com/qingger/serviceCenter/blob/master/Projects/EmpService/DevelopAPI/userLogin/portalOAUTH2Login.md
     */
    EMP_POST_TOKEN: resolveEmpURLConfig('/auth/token', HttpMethod.POST, 'EMP_POST_TOKEN', { auth: false }),
    NEW_EMP_POST_TOKEN: resolveNewEmpURLConfig('/auth/token', HttpMethod.POST, 'NEW_EMP_POST_TOKEN', { auth: false }),
    // EMP_POST_TOKEN : {
    //     name : "EMP_POST_TOKEN",
    //     baseURL : API_BASE_URL,
    //     path    : '/auth/token',
    //     version : 1,
    //     method  : "POST",
    //     auth    : false,
    //     postParams : ['apiId','target','nonce','timestamp','code','apiSign']
    // },

    /**
     * 刷新EmpService的Token
     */
    EMP_REFRESH_TOKEN: resolveEmpURLConfig('/auth/refresh/token', HttpMethod.POST, 'EMP_REFRESH_TOKEN'),
    NEW_EMP_REFRESH_TOKEN: resolveNewEmpURLConfig('/auth/refresh/token', HttpMethod.POST, 'NEW_EMP_REFRESH_TOKEN'),
    // EMP_REFRESH_TOKEN : {
    //     name : "EMP_REFRESH_TOKEN",
    //     baseURL : API_BASE_URL,
    //     path    : '/auth/refresh/token',
    //     version : 1,
    //     method  : "POST",
    //     auth    : true,
    //     postParams : []
    // },

    /**
     * 根据Token获得用户信息
     * @see http://git.project.qingger.com/qingger/serviceCenter/blob/master/Projects/EmpService/DevelopAPI/userLogin/tokenUserInfo.md
     */
    EMP_AUTH_EMP_INFO: resolveEmpURLConfig('/user/auth/empInfo', HttpMethod.GET),
    NEW_EMP_AUTH_EMP_INFO: resolveNewEmpURLConfig('/user/auth/empInfo', HttpMethod.GET),
  };
}
